import { render } from "./LoyaltyArea.vue?vue&type=template&id=2dae7931&scoped=true"
import script from "./LoyaltyArea.vue?vue&type=script&lang=js"
export * from "./LoyaltyArea.vue?vue&type=script&lang=js"

import "./LoyaltyArea.vue?vue&type=style&index=0&id=2dae7931&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dae7931"]])

export default __exports__